import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Result } from 'antd';
import UIStore from '../stores/UIStore';
import Talking from 'assets/images/error.svg';

const NoMatch = (props: any) => {
    useEffect(() => {
        UIStore.setDocumentTitle('404');
    }, []);

    return (
        <div className="grid">
            <div className="m-auto pt-20">
                <img width="350px" src={Talking} />
            </div>
            <div className="m-auto pt-10">
                <Button>
                    <Link to="/my-account">Back to Home</Link>
                </Button>
            </div>
            <div className="m-auto font-extrabold text-lg pt-5">
                <h3>404</h3>
            </div>
            <div className="m-auto font-black">
                <h4>The page you visited does not exist.</h4>
            </div>
        </div>
    );
};

export default NoMatch;
